const RecipeRow = ({ recipeIngredient }) => {
  const format = () => {
    return recipeIngredient?.measurement
      ? recipeIngredient?.quantity +
          " " +
          recipeIngredient?.measurement?.description +
          " " +
          recipeIngredient?.ingredient?.name
      : recipeIngredient?.quantity + " " + recipeIngredient?.ingredient?.name;
  };
  return <li>{format()}</li>;
};
export default RecipeRow;
